var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Modal from 'react-modal';
import { useForm } from "react-hook-form";
import { AccountTransactionApi } from "../../subpages/accountTransactions/account.transactions.api";
import { Storage } from "../../../../lib/localstorege.service";
import { customStyles } from "../../../../definitions/constants/modal.constant";
import { modalServiceSubject } from "../../../../components/modal/modal";
import { member } from "../../../../store/login.store";
import CheckCircle from "../../../../assets/feather/check-circle.svg";
import MinusCircle from "../../../../assets/feather/minus-circle.svg";
function EmailUpdate() {
    var _a = React.useState(false), modalIsOpenEmail = _a[0], setIsOpenEmail = _a[1];
    var token = Storage.get('token');
    function openModalEmail() {
        setIsOpenEmail(true);
    }
    function closeModal() {
        setIsOpenEmail(false);
    }
    var _b = useForm(), register = _b.register, handleSubmit = _b.handleSubmit, errors = _b.formState.errors;
    var onSubmit = function (data) {
        updateEmailApi(data);
    };
    var updateEmailApi = function (data) {
        data.token = token;
        if (navigator.onLine) {
            AccountTransactionApi.updateEmailMember(data).then(function (result) {
                if (result.status) {
                    setIsOpenEmail(false);
                    modalServiceSubject.next({
                        title: "Uyarı!",
                        content: result.message,
                        confirm: {
                            cancel: { label: 'Tamam' }
                        },
                        timeout: 0
                    });
                }
                else {
                    modalServiceSubject.next({
                        title: "Uyarı!",
                        content: result.message,
                        confirm: {
                            cancel: { label: 'Tamam' }
                        },
                        timeout: 0
                    });
                }
            }).catch(function (error) {
                modalServiceSubject.next({
                    title: "Uyarı!",
                    content: error,
                    confirm: {
                        cancel: { label: 'Tamam' }
                    },
                    timeout: 0
                });
            });
        }
        else {
            modalServiceSubject.next({
                title: "Uyarı!",
                content: "İnternet bağlantınızı kontrol ediniz.",
                confirm: {
                    cancel: { label: 'Tamam' }
                },
                timeout: 0
            });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "table row" }, { children: _jsxs("div", __assign({ className: "col-12" }, { children: [_jsx("label", { children: "Eposta" }, void 0), _jsxs("div", __assign({ className: "form-control" }, { children: [member.email, _jsx("i", __assign({ className: "ml-2" }, { children: member.email_verified ? (_jsx("img", { title: "Do\u011Frulanm\u0131\u015F mail adresi", src: CheckCircle, width: 16, height: 16 }, void 0)) : (_jsx("img", { title: "Do\u011Frulanmam\u0131\u015F", src: MinusCircle, width: 16, height: 16 }, void 0)) }), void 0), _jsx("a", __assign({ href: "#", className: "btn btn-small btn-primary float-right", onClick: function () { return openModalEmail(); } }, { children: "De\u011Fi\u015Ftir" }), void 0), member.email_verified
                                    ? _jsx(_Fragment, {}, void 0)
                                    : _jsx(_Fragment, { children: _jsx("a", __assign({ href: "#", className: "btn btn-small btn-primary float-right", onClick: function () { return updateEmailApi({ 'email': member.email }); } }, { children: "Do\u011Frula" }), void 0) }, void 0)] }), void 0)] }), void 0) }), void 0), _jsx(Modal, __assign({ isOpen: modalIsOpenEmail, onRequestClose: closeModal, style: customStyles, contentLabel: "" }, { children: _jsxs("div", __assign({ className: "page card" }, { children: [_jsx("div", __assign({ className: "card-title d-flex justify-content-center" }, { children: _jsx("h3", { children: "Eposta G\u00FCncelleme" }, void 0) }), void 0), _jsx("label", { children: "L\u00FCtfen yeni eposta adresinizi girip onaylay\u0131n\u0131z." }, void 0), _jsx("div", __assign({ className: "card-body d-flex justify-content-center" }, { children: _jsx("div", __assign({ className: "table row  d-flex justify-content-center" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [_jsxs("div", { children: [_jsx("input", __assign({ className: "form-control", placeholder: "E-Posta" }, register('email', { required: true }), { type: "email" }), void 0), errors.email && errors.email.type === "required" && _jsx("span", __assign({ className: "text-validation" }, { children: "L\u00FCtfen ge\u00E7erli bir eposta adresi giriniz." }), void 0)] }, void 0), _jsx("div", __assign({ className: "d-flex justify-content-center" }, { children: _jsx("input", { className: "btn btn-primary btn-large mt-3", type: "submit" }, void 0) }), void 0)] }), void 0) }), void 0) }), void 0) }), void 0)] }), void 0) }), void 0)] }, void 0));
}
export default EmailUpdate;
